import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { OuiTableModule } from 'omnium-ui/table';
import { OuiTagModule } from 'omnium-ui/tag';
import { ConsultantCardComponent } from '../../../../../../core/components/consultant-card/consultant-card.component';
import { InvestorViewerConsultantAssignment } from '../../../../../../core/models/api.models';
import { ConsultantRelationTagComponent } from '../../../../shared/consultant-relation-tag/consultant-relation-tag.component';
import { formatDate, formatText } from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-consultants-section',
  imports: [
    MatTableModule,
    OuiTableModule,
    OuiTagModule,
    ConsultantCardComponent,
    ConsultantRelationTagComponent,
    InvestorViewerAccordionComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './investor-viewer-consultants-section.component.html'
})
export class InvestorViewerConsultantsSectionComponent {
  readonly assignments = input.required<InvestorViewerConsultantAssignment[]>();
  protected readonly consultantColumns = ['relation', 'consultant', 'email', 'status', 'dates', 'identifiers'];
  protected readonly formatText = formatText;
  protected readonly formatDate = formatDate;
}
